import { render, staticRenderFns } from "./EnableFeature.vue?vue&type=template&id=48e23460&scoped=true"
import script from "./EnableFeature.vue?vue&type=script&lang=js"
export * from "./EnableFeature.vue?vue&type=script&lang=js"
import style0 from "./EnableFeature.vue?vue&type=style&index=0&id=48e23460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e23460",
  null
  
)

export default component.exports